import React, { useState } from 'react'
import HOC from '../../components/HOC/HOC'
import addjob from '../../css/style.module.css'
import { useNavigate } from 'react-router-dom';
import { SuccessfullyModal } from '../../components/Modals/Modals'
import { postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

const AddPrivacyPolicy = () => {
    const navigate = useNavigate()
    const [show, setShow] = useState(false)
    const [loading, setLoading] = useState(false);
    const [policyDetails, setPolicyDetails] = useState('');
    const policyTitle = 'Privacy Policy';




    const handleSubmit = async () => {
        const payload = {
            title: policyTitle,
            description: policyDetails,
        };

        await postApi(endPoints.addprivacy, payload, {
            setLoading,
            successMsg: 'Privacy Policy added successfully!',
            errorMsg: 'Failed to add privacy policy!',
        });
        setShow(true);

        setTimeout(() => {
            setShow(false);
            navigate('/privacypolicy'); // Redirect to the Privacy Policy list page
        }, 2000);
    };
    return (
        <>
            <SuccessfullyModal
                show={show}
                handleClose={() => setShow(false)}
                text="Successfully Added"
            />
            <div className={addjob.jobmanagementCotainer}>
                <div className={addjob.jobtoppart}>
                    <div className={addjob.pagetitle}>
                        <h6>Add Privacy Policy</h6>
                    </div>
                    <div className={addjob.rightbuttons}>
                        <div className={addjob.rightbuttons2} onClick={() => navigate(-1)}>
                            <p>View Policies</p>
                        </div>
                    </div>
                </div>

                <div className={addjob.addjobcontainer}>
                    <div className={addjob.addjobsubcontainer}>
                        <div className={addjob.addjobtopic}>
                            <h6>Policy Details</h6>
                        </div>
                        <div className={addjob.editprivacypolicy}>
                            <label htmlFor="policyDetails">Add Policy Details*</label>
                            <textarea
                                id="policyDetails"
                                placeholder="Add the policy details here..."
                                value={policyDetails}
                                onChange={(e) => setPolicyDetails(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className={addjob.addjobbutton}>
                        <div className={addjob.rightbuttons}>
                            <button onClick={() => navigate(-1)}>Cancel</button>
                        </div>
                        <div className={addjob.rightbuttons}>
                            <button
                                onClick={handleSubmit}
                                style={{ background: '#F05423' }}
                                disabled={loading || !policyDetails.trim()}
                            >
                                {loading ? "Adding..." : "Add"}
                            </button>
                        </div>
                    </div>

                </div>

            </div >
        </>
    )
}

export default HOC(AddPrivacyPolicy)